(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["holyseek-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const dayMs = 86400000;
    const holidayCache = new Map();
    const iso = (date) => date.toISOString().slice(0, 10);
    const nextDay = (date) => new Date(date.getTime() + dayMs);
    function easter(year) {
      const a = year % 19, b = Math.floor(year / 100), c = year % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      return new Date(Date.UTC(year, month - 1, ((h + l - 7 * m + 114) % 31) + 1));
    }
    function holidays(year) {
      if (!holidayCache.has(year)) {
        const days = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].map((day) => `${year}-${day}`);
        const sunday = easter(year);
        for (const offset of [1, 39, 50]) days.push(iso(new Date(sunday.getTime() + offset * dayMs)));
        holidayCache.set(year, new Set(days));
      }
      return holidayCache.get(year);
    }
    function addWorkingDays(start, count) {
      let date = new Date(start);
      let remaining = count;
      for (let step = 0; remaining > 0 && step < 366; step++) {
        date = nextDay(date);
        if (date.getUTCDay() !== 0 && !holidays(date.getUTCFullYear()).has(iso(date))) remaining--;
      }
      if (remaining) throw new RangeError('Delivery range exceeds supported calendar');
      return date;
    }
    class HolySeekDelivery extends HTMLElement {
      static estimate(now, preparation = 1, minimum = 2, maximum = 3) {
        if (![preparation, minimum, maximum].every((value) => Number.isInteger(value) && value >= 1 && value <= 30) || maximum < minimum) throw new RangeError('Invalid delivery settings');
        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
        const part = (type) => Number(parts.find((value) => value.type === type).value);
        const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
        const dispatch = addWorkingDays(today, preparation);
        return { dispatch, first: addWorkingDays(dispatch, minimum), last: addWorkingDays(dispatch, maximum) };
      }
      connectedCallback() {
        this.country = this.querySelector('[data-delivery-country]');
        this.messages = JSON.parse(this.querySelector('[data-delivery-messages]').textContent);
        this.onChange = () => this.render();
        this.onVisibility = () => { if (!document.hidden) this.render(); };
        this.country.addEventListener('change', this.onChange);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.timer = setInterval(this.onChange, 60000);
        this.observer = new MutationObserver(this.onChange);
        this.section = this.closest('.shopify-section');
        if (this.section) this.observer.observe(this.section, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
        this.render();
      }
      disconnectedCallback() {
        this.country?.removeEventListener('change', this.onChange);
        document.removeEventListener('visibilitychange', this.onVisibility);
        clearInterval(this.timer);
        this.observer?.disconnect();
      }
      render() {
        const button = this.section?.querySelector('button[type="submit"][name="add"]');
        const available = button ? !button.disabled : this.dataset.available === 'true';
        const country = this.country.value;
        const range = this.querySelector('[data-delivery-range]');
        const fallback = this.querySelector('[data-delivery-fallback]');
        const note = this.querySelector('[data-delivery-note]');
        const show = available && country === 'FR';
        range.hidden = !show;
        note.hidden = !show;
        fallback.hidden = show;
        const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
        if (!show) {
          setText(fallback, !available ? this.messages.unavailable : country === 'BE' ? this.messages.belgium : this.messages.choose);
          return;
        }
        try {
          const result = HolySeekDelivery.estimate(new Date(), Number(this.dataset.preparation), Number(this.dataset.transitMin), Number(this.dataset.transitMax));
          const formatter = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', ...(result.first.getUTCFullYear() !== result.last.getUTCFullYear() ? { year: 'numeric' } : {}) });
          setText(this.querySelector('[data-delivery-first]'), formatter.format(result.first));
          setText(this.querySelector('[data-delivery-last]'), formatter.format(result.last));
        } catch {
          range.hidden = true;
          note.hidden = true;
          fallback.hidden = false;
          setText(fallback, this.messages.choose);
        }
      }
    }
    if (!customElements.get('holyseek-delivery')) customElements.define('holyseek-delivery', HolySeekDelivery);
  })();
  } catch(e) { console.error(e); }
})();

})();
